import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import "./manufacturing";
import "./logistics.css";
import Footer from "../components/Footer.js";

import Button from "react-bootstrap/Button";
import Navbar from "../components/Navbar.js";

// Correction: Imported images while replacing some images with updated ones
import loisticshero from '../assets/Logistics/LogisticsHeroCover.png'
import loisticstab1 from '../assets/Logistics/LogisticsTab1.png'
import loisticstab2 from '../assets/Logistics/LogisticsTab2.png'
import loisticstab3 from '../assets/Logistics/LogisticsTab3.png'
import loisticstab4 from '../assets/Logistics/LogisticsTab4.png'

import Icon1 from "../assets/Industry/Truck.png"
import Icon2 from "../assets/Industry/Checklist.png"
import Icon3 from "../assets/Industry/DeliveryBox.png"
import Icon4 from "../assets/Industry/PeakPerformance.png"

const Logistics = () => {
 
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("route");

  const tabs = [
    { id: "route", label: "Route Management" },
    { id: "operation", label: "Operation Monitoring" },
    { id: "delivery", label: "Delivery Management" },
    { id: "vehicle", label: "Vehicle Health Report" },
  ];

  const tabContents = {
    route: {
      title: "LIVE VEHICLE ROUTE TRACKING",
      list: [
        "Plan and monitor vehicle routes across the network",
        "Track in/out time at loading zones and entry gates",
        "Improve dock allocation and reduce congestion",
        "Minimize wait time and improve driver throughput",
      ],
      image: loisticstab1,
    },
    operation: {
      title: "REAL TIME OPERATION TRACKING",
      list: [
        "Live GPS-based tracking across all assets",
        "Delay, detour, and risk alerts in real time",
        "Visibility across drivers, shipments, and ETAs",
        "One dashboard for all moving parts",
      ],
      image: loisticstab3,
    },
    delivery: {
      title: "DELIVERY FULFILLMENT MANAGEMENT",
      list: [
        "Automate order dispatch and shipment scheduling",
        "Monitor fulfillment status across all delivery points",
        "Track delivery SLAs and performance in real time",
      ],
      image: loisticstab2,
    },
    vehicle: {
      title: "ASSET & FLEET MAINTENANCE",
      list: [
        "Predictive maintenance based on usage and wear for Vehicle Health status",
        "Auto-generated service schedules",
        "Track service logs across your fleet",
        "Improve uptime and extend asset life",
      ],
      image: loisticstab4,
    },
  };

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>

      <div className="container-mirrored">
        <div className="image-section-mirrored">
          <img src={loisticshero} alt="Product Line" />
        </div>
        <div className="content-mirrored">
          <h1 className="context-">
           Every Package. Every<br/> Route. Always in Sync.
          </h1>
          <h4 style={{ fontWeight: "300" }}>
            We help you reduce delivery errors, cut downtime, and stay steps
            ahead—no chasing, no guessing
          </h4>
          <Button onClick={()=>{navigate('/Demo')}} className="know-more-btn">
            Get Started
          </Button>
        </div>
      </div>

      <div className="centered-section">
        <h2 className="centered-section-h">How We Bring Clarity to <br />Every Move</h2>
        <h6 className="centered-section-p">
          From tracking to turnaround, this video breaks down how our platform
          helps you plan better,<br/> respond faster, and keep operations
          flowing—without the daily firefighting.
        </h6>
      </div>

      <div className="app2">
        <div className="app-container2">
         
       
        <div className="tabs2">
          {Object.keys(tabContents).map((tabKey) => (
            <button
              key={tabKey}
              className={`tab2 ${activeTab === tabKey ? "active2" : ""}`}
              onClick={() => setActiveTab(tabKey)}
            >
              {tabs.find((tab) => tab.id === tabKey)?.label}
            </button>
          ))}
        </div>
       </div>
        <div className="content2">
          <div className="text-column2">
            <h2>{tabContents[activeTab].title}</h2>
            <hr />
            <p>
              {tabContents[activeTab].list.map((desc, index) => (
                <div key={index}>• {desc}</div>
              ))}
            </p>
          </div>
          <div className="image-column2">
            <img
              src={tabContents[activeTab].image}
              alt={tabContents[activeTab].title}
            />
          </div>
        </div>
        
      </div>

      <div className="app-container2">
        <header className="app-header2">
          <h1 className="title2">The Scorecard of Progress</h1>
        </header>

        <div className="statistics-container2">
          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+35%</h2>
            <p className="statistic-description21">
              Faster Vehicle Turnaround Time
            </p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              With Real-time Flow Monitoring
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-50%</h2>
            <p className="statistic-description21">Idle Time per Vehicle</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">By Reducing Delays</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+15%</h2>
            <p className="statistic-description21">
              Automatic Checkpoints Logged
            </p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">With No Manual Paperwork</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-30%</h2>
            <p className="statistic-description21">Visibility Across Fleet</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              Through better Route Visibility
            </p>
          </div>
        </div>
      </div>

      <div className="app-container3">
        <div className="content3" style={{ textAlign: "left" }}>
          <h1 className="title3">
            {" "}
            Argus Turns Data
            <br /> Into Delivery{" "}
          </h1>
          <Button
            onClick={()=>{navigate('/contact')}}
            className="connect-button3"
          
          >
            Connect Now
          </Button>
        </div>

        <div className="card-container3">
          <div className="card3">
            <div className="icon3">
              <img src={Icon1} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Faster vehicle turnaround, More Order Rate
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon2} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">Real-time control over Daily Ops</h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon3} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Consistency accurate with Timely Dispatches
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon4} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Lower Downtime, Higher Fleet Reliability
            </h3>
          </div>
        </div>
        
      </div>
      <div>
      </div>
      <Footer />
    </div>
  );
};

export default Logistics;
